import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';


interface TrustFeature {
  id: number;
  icon: string;
  title: string;
  description: string;
}

interface TrustSectionProps {
  features: TrustFeature[];
}

const TrustSection = ({ features }: TrustSectionProps) => {
  const { t } = useLanguage();

  return (
    <section className="py-20 lg:py-28 bg-secondary relative overflow-hidden">
      <div className="relative mx-auto max-w-content px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-6 tracking-tight">
            {t('home.trust.title')}
          </h2>
          <div className="w-24 h-1 bg-gradient-gold mx-auto rounded-full" />
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature) =>
          <div
            key={feature.id}
            className="group bg-white rounded-2xl p-10 shadow-luxury-sm hover:shadow-luxury-lg transition-luxury hover:-translate-y-2 border border-border/50">
              {/* Icon */}
              <div className="w-20 h-20 bg-gradient-to-br from-accent/10 to-accent/5 rounded-xl flex items-center justify-center mb-8 group-hover:shadow-gold-glow transition-luxury">
                <Icon
                name={feature.icon as any}
                size={36}
                className="text-accent"
                variant="outline" />

              </div>

              {/* Title */}
              <h3 className="font-heading text-2xl font-semibold text-primary mb-4 tracking-tight">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="font-body text-base text-muted-foreground leading-relaxed">
                {feature.description}
              </p>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default TrustSection;